import { PlatformSiteAri } from '@atlassian/ari';

import { query, queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { shouldUseAGGActivityV3 } from '@confluence/home/entry-points/shouldUseAGGActivityV3.ts';

import { PAGE_SIZE, OBJECT_TYPES } from './recentQueryConstants.ts';
import { RecentContentMenuQuery } from './queries/RecentContentMenuQuery.graphql.ts';

export function preloadRecentContentMenu(cloudId) {
	return (shouldUseAGGActivityV3() ? queryAgg : query)({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: RecentContentMenuQuery,
		variables: {
			cloudId: PlatformSiteAri.create({ siteId: cloudId }).toString(),
			after: '',
			first: PAGE_SIZE,
			eventTypes: [],
			objectTypes: OBJECT_TYPES,
		},
		fetchPolicy: 'network-only',
	});
}
